import { createRoute } from "./helpers";

const designationRoutes = {
  children: [
    createRoute("/designations/acknowledge", "Designations/DesignationPage"),
  ],
};

export default designationRoutes;
